
import CardView from "./CardView.vue";
import MoreLeft from "./MoreLeft.vue";
import MoreRight from "./MoreRight.vue";
export default {
  components: { MoreLeft, MoreRight, CardView },
  name: "More",
};
